import React, { useRef, useState, useEffect } from 'react';
import { func, string, bool } from 'prop-types';
import styled from 'styled-components';

const UploadBtn = styled.div`
  position: relative;
  display: block;
  width: 100%;

  && label {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    color: white;
    font-weight: 400;
    font-size: 18px;
  }

  .cloud {
    width: 100%;
    height: unset;
    opacity: ${props => (props.disabled ? 0.4 : 1)};
  }

  button {
    background: transparent;
    border: none;
    width: 45px;
    padding: 0;
    cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  }

  button:focus {
    outline: none;
  }

  button.remove-btn {
    width: auto;
    padding: 4px;
    color: #ffffff;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: color 0.15s ease-in-out;
  }

  button.remove-btn:hover {
    color: #ff7979;
  }

  .upload-tooltip {
    visibility: hidden;
    opacity: 0;
    background-color: #1f2231;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 8px 12px;
    position: absolute;
    z-index: 10;
    bottom: 100%;
    right: 0;
    font-size: 12px;
    width: max-content;
    max-width: 220px;
    border: 1px solid #383d54;
    transition: opacity 0.2s;
    pointer-events: none;
    margin-bottom: 6px;
  }

  .upload-tooltip::after {
    content: "";
    position: absolute;
    top: 100%;
    right: 18px;
    border-width: 5px;
    border-style: solid;
    border-color: #1f2231 transparent transparent transparent;
  }

  &:hover .upload-tooltip {
    visibility: visible;
    opacity: 1;
  }
`;

const TrashIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6" />
    <path d="M14 11v6" />
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);

const UploadImgBtn = ({ setImg, label, disabled, tooltip, onRemove }) => {
  const [uploadedOk, setUploadedOk] = useState(false);
  const hiddenFileInput = useRef(null);

  useEffect(() => {
    if (disabled) {
      setUploadedOk(false);
    }
  }, [disabled]);

  const handleClick = () => {
    if (disabled) return;
    hiddenFileInput.current.click();
  };

  const handleRemove = e => {
    e.preventDefault();
    e.stopPropagation();
    setUploadedOk(false);
    if (hiddenFileInput.current) {
      hiddenFileInput.current.value = '';
    }
    if (onRemove) onRemove();
  };

  return (
    <UploadBtn disabled={disabled}>
      <label htmlFor="linti">
        {label}
        {uploadedOk && (
          <button
            type="button"
            className="remove-btn"
            onClick={handleRemove}
            aria-label="Quitar foto"
            title="Quitar foto"
          >
            <TrashIcon />
          </button>
        )}
        {uploadedOk ? (
          <button type="button" id="linti" onClick={handleClick} disabled={disabled}>
            <img src="../../../images/icons/cloud-ok.png" className="cloud" alt="linti" />
          </button>
        ) : (
          <button type="button" id="linti" onClick={handleClick} disabled={disabled}>
            <img src="../../../images/icons/upload-img-btn.png" className="cloud" alt="linti" />
          </button>
        )}
        {disabled && tooltip && <span className="upload-tooltip">{tooltip}</span>}
        <input
          id="linti"
          type="file"
          accept="image/*"
          ref={hiddenFileInput}
          style={{ display: 'none' }}
          disabled={disabled}
          onChange={e => {
            setImg(e.target.files[0]);
            setUploadedOk(true);
          }}
        />
      </label>
    </UploadBtn>
  );
};

UploadImgBtn.propTypes = {
  setImg: func.isRequired,
  label: string,
  disabled: bool,
  tooltip: string,
  onRemove: func,
};

UploadImgBtn.defaultProps = {
  label: '',
  disabled: false,
  tooltip: '',
  onRemove: null,
};

export default UploadImgBtn;
